import styled from 'styled-components'

export const UnstyledButton = styled.button`
  background-color: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/base/Buttons/index.tsx